import React, { useEffect, useState } from "react";
import { Select } from "antd";
// import css from "./index.less";
import EnhanceTip from "./common/enhanceTip";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

export default ({
  data,
  getText,
  setRetrieveValues,
  btnRequestHandle,
  setSubmitState,
  isStreaming,
}: {
  data: IMultiElementCombineMsg.ISelectMenuElem;
  getText: (text: IMultiElementCombineMsg.IText | string | undefined) => string;
  setRetrieveValues: (value: IMultiElementCombineMsg.IRetrieveValues) => void;
  btnRequestHandle: ({
    url,
    elem,
    extra,
  }: IMultiElementCombineMsg.ISubmitParams) => void;
  setSubmitState: (tipCheck: IMultiElementCombineMsg.ITipCheck) => void;
  isStreaming: boolean;
}) => {
  const {
    id,
    type,
    title,
    default_id,
    options = [],
    placeholder_title = "",
    disable,
    action_url,
    prompt_tips,
    required,
    required_tips,
    extra,
  } = data;

  const style = getDefaultComponentStyle(data);

  const getSelectItem = (selectId?: string) => {
    if (!selectId) return {};

    const selectedItem = options.find((item) => item.id === selectId);
    if (!selectedItem) return {};

    selectedItem.value = getText(selectedItem.text);
    return selectedItem;
  };

  const [selectedVal, setSelectedVal] = useState(() => {
    return getSelectItem(default_id);
  });

  useEffect(() => {
    const selectedItem = getSelectItem(default_id);
    setSelectedVal(selectedItem);
  }, [default_id]);

  const optionsVal = () => {
    let _options = [...options];
    _options.forEach((item) => {
      item.value = getText(item.text);
    });
    return _options;
  };

  // IMultiElementCombineMsg.IOptionItem
  const selectChange = (val: string, option: any) => {
    setSelectedVal(option);
    const value = option.id || "";
    // if (required && !value) return;
    action_url &&
      btnRequestHandle({ url: action_url, elem: { id, type, value }, extra });
  };

  useEffect(() => {
    setRetrieveValues({ id, type, value: selectedVal.id || "" });
  }, [selectedVal]);

  return (
    <div style={style}>
      <EnhanceTip
        id={id}
        isEmpty={!selectedVal.value}
        required={required}
        required_tips={required_tips}
        prompt_tips={prompt_tips}
        isLeftGap={!!getText(title)}
        setSubmitState={setSubmitState}
      >
        <div className={"sscard-flexBox"} id={`selectElem-${id}`}>
          {getText(title) && <span className={"desc"}>{getText(title)}</span>}
          <Select
            value={selectedVal.value}
            placeholder={getText(placeholder_title)}
            style={{ width: 120 }}
            className={`${"selectItem"}`}
            disabled={isStreaming || !!disable}
            onChange={selectChange}
            onClick={(e) => e.stopPropagation()}
            options={optionsVal() as any}
            getPopupContainer={() =>
              document.getElementById(`selectElem-${id}`) as HTMLElement
            }
          />
        </div>
      </EnhanceTip>
    </div>
  );
};
